import { AnimatePresence, motion } from 'framer-motion';
import styles from './termSheetPreviewGroup.module.scss';
import { slideInOut } from '@baseline/ui';
import { OutputFieldConfig } from '@/services/termSheet/types/common';
import { cx } from 'class-variance-authority';
import { Fragment } from 'react';

export default function TermSheetPreviewGroup({
  title,
  fields
}: {
  title: string;
  fields: OutputFieldConfig[];
}) {
  return (
    <div className={styles.termSheetPreviewGroup}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.fields}>
        {fields
          .filter((field) => !field.hide)
          .map((field, index) => (
            <Fragment key={index}>
              {field.topDivider && <div className={styles.fieldTopDivider} />}
              <div className={styles.fieldRow}>
                <div
                  className={cx(
                    styles.label,
                    field.bold && styles.boldFieldLabel
                  )}
                >
                  {field.label}
                </div>

                <AnimatePresence initial={false} mode="popLayout">
                  {field.isValueVisible ? (
                    <motion.div
                      {...slideInOut()}
                      key={index}
                      className={styles.value}
                    >
                      {field.value}
                    </motion.div>
                  ) : (
                    <motion.div
                      {...slideInOut()}
                      key="skeleton"
                      className={styles.skeleton}
                    />
                  )}
                </AnimatePresence>
              </div>
            </Fragment>
          ))}
      </div>
    </div>
  );
}
